import { useContext, useMemo } from 'react'

import { MobXProviderContext } from 'mobx-react'

import { IResourceFieldCatalog } from '../catalog/types'
import { IResourceRuntimeContext } from '../definitions'
import { createResourceFieldProjector } from './createResourceFieldProjector'

export const getProjectorStores = (stores: any) => ({
  projectDateStore: stores.projectDateStore,
  projectMembersStore: stores.projectMembersStore,
  companiesStore: stores.companiesStore,
  tagsStore: stores.tagsStore,
})

export function useResourceFieldProjector({
  catalog,
  resourceTypeId,
  runtimeContext,
}: {
  catalog: Pick<IResourceFieldCatalog, 'fields' | 'getField'>
  resourceTypeId?: string
  runtimeContext: IResourceRuntimeContext
}) {
  const stores = useContext(MobXProviderContext) as any

  return useMemo(
    () =>
      createResourceFieldProjector({
        catalog,
        resourceTypeId,
        runtimeContext,
        ...getProjectorStores(stores),
      }),
    [catalog, resourceTypeId, runtimeContext, stores],
  )
}
